import React from 'react'
import { Container } from 'react-bootstrap'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination, Navigation, EffectFade } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import 'swiper/css/effect-fade'

const Homebanner = () => {
  const slides = [
    {
      image: 'assets/images/screen-1.png',
      subtitle: 'Welcome To Lindsay Drive-In',
      title: 'Reserve Your Spot For Screen 1',
      highlight: 'Screen 1',
      description:
        'Book tickets for the latest movies, choose your preferred screen, and order food for a complete drive-in movie experience.',
    },
    {
      image: 'assets/images/screen-2.png',
      subtitle: 'Two Screens, One Great Night',
      title: 'Book Your Movie On Screen 2',
      highlight: 'Screen 2',
      description:
        'Explore more showtimes on our second screen, reserve your tickets online, and enjoy your favorite food while you watch.',
    },
  ]

  return (
    <div className="movie-banner-slider">
      <Swiper
        modules={[Autoplay, Pagination, Navigation, EffectFade]}
        effect="fade"
        loop={true}
        speed={900}
        autoplay={{
          delay: 4500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        className="home-banner-swiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className="banner-sec movie-banner-sec"
              style={{ backgroundImage: `url('${slide.image}')` }}
            >
              <Container>
                <div className="banner-content text-center">
                  <span className="banner-subtitle">{slide.subtitle}</span>

                  <h1>
                    {slide.title.split(slide.highlight)[0]}
                    <span>{slide.highlight}</span>
                    {slide.title.split(slide.highlight)[1]}
                  </h1>

                  <p className="banner-text">{slide.description}</p>

                  <div className="banner-btn-wrap">
                    <a href="/theatres" className="cmn-btn">
                      Book Tickets
                    </a>

                   
                  </div>
                </div>
              </Container>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default Homebanner